import React from 'react';
import { useAuth } from '../../context/AuthContext';
import PanelAvanzado from './PanelAvanzado';

const AdminAdvancedDashboard = () => {
  const { user } = useAuth();

  // Verificar que el usuario sea admin
  if (!user || user.rol !== 'admin') {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <div className="text-center">
          <h2 className="text-2xl font-bold text-red-600 mb-4">Acceso Denegado</h2>
          <p className="text-gray-600">Esta sección es exclusiva para administradores.</p>
        </div>
      </div>
    );
  }

  return <PanelAvanzado />;
};

export default AdminAdvancedDashboard;